import { useQuery, UseQueryResult } from "react-query";
import { PipelineImport } from "./types";
import { get } from "./api";


export default function useGetPipelineImports(workspaceId: string, schemaId?: string): UseQueryResult<PipelineImport[]> {
  return useQuery(["pipeline-imports", workspaceId, schemaId], () => (workspaceId ? getPipelineImports(workspaceId, schemaId) : []));
}

async function getPipelineImports(workspaceId: string, schemaId?: string): Promise<PipelineImport[]> {
  const response = await get(`pipeline-imports/${workspaceId}${schemaId ? `?schemaId=${schemaId}` : ""}`);

  if (!response.ok) throw response.error;

  return response.data;
}